export default "__VITE_ASSET__BZVl_KxW__"